const Handlebars = require('handlebars/runtime');

module.exports = {
    register (locator) {
        locator.registerInstance('handlebars', Handlebars);
    }
};



// WEBPACK FOOTER //
// ./services/handlebars/browser.js